import { render, staticRenderFns } from "./createRoom.vue?vue&type=template&id=5c61d8ed&lang=pug&"
import script from "./createRoom.vue?vue&type=script&lang=js&"
export * from "./createRoom.vue?vue&type=script&lang=js&"
import style0 from "./createRoom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports